import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import IconFont from '../common/iconfont';
import Store from '../../script/store';
import Utils from '../../script/utils';
import * as alarmActions from '../../actions/alarm_action';
import {DownOutlined} from '@ant-design/icons'
import * as settingActions from '../../actions/setting_action';
import * as navbarActions from '../../actions/navbar_action';
import * as deviceMonitorActions from '../../actions/deviceMonitor_action';
import * as equipmentActions from '../../actions/equipment_action';
import * as loginActions from '../../actions/login_action';
import styles from './layout.module.less'
// import Sockette from 'sockette';
// import * as operationAuditActions from '../../actions/operationAudit_action';
import ChangePasswordFormModal from '../setting/changePasswordFormModal';
import UserFormModal from '../setting/userFormModal';
import DrawerEventLogsView from '../../pages/alarm/components/drawerEventLogsView';
import { Layout, Menu, Icon, Row, Divider, Form, Button, Tag, Modal, Popover, Drawer, Badge, Tabs, Dropdown, Tooltip } from 'antd';
import {
  MenuFoldOutlined,MenuUnfoldOutlined,FullscreenExitOutlined ,FullscreenOutlined ,UserOutlined ,TeamOutlined ,KeyOutlined,
  PoweroffOutlined,DashboardOutlined,DownloadOutlined
} from '@ant-design/icons';
const { Header, Footer, Sider, Content } = Layout;
const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;
const TabPane = Tabs.TabPane;

let timeInterval = null;
let ws = null;
const style={color: '#fff', fontSize: 22, marginRight: 8, cursor: 'pointer'}
class AppNavbar extends Component {
  state={
    userManageModalShow: false,
    topMenu: '0',
    groupTreeNode: {},
    isFullscreen: false,
    nodeData:{name: "IT资源树", id: "se"},
    drawerVisible: false,
    alarmEventLogs: [],
    systemError:0,
    systemWarning:0,
    personalInfoModalShow: false,
    personalInfo: {}
  }

  componentDidMount(){
    this.getSelfCheckData();
    this.getAlarmEventLogs();
    // 检测全屏变化
    screenfull.on('change', () => {
      if (screenfull.isFullscreen) {
        this.setState({ isFullscreen: true });
      } else {
        this.setState({ isFullscreen: false });
      }
  	});
    timeInterval = setInterval(() => {  //每5分钟刷新一下 系统检测数据和报警事件数据
      this.getSelfCheckData();
      this.getAlarmEventLogs();
    }, 300*1000);
    // WebSocket 暂未接入（新后端无 ws 推送，改用轮询 selfcheck/alarmEvent），先注释
    // this.props.navbarActions.initWebSocket();
  }

  componentWillReceiveProps(nextProps) {
  }

  componentWillUnmount() {
    // this.props.navbarActions.closeWebSocket();
    if (timeInterval) {
      clearInterval(timeInterval);
      timeInterval = null;
    }
  }

  getSelfCheckData = () => {
    this.props.settingActions.getSelfCheckData((data)=>{
      const { selfCheckData } = this.props;
      const { systemError, systemWarning } = this.state;
      var goodNum = 0, warningNum = 0, errorNum = 0;
      for (var i = 0; i < selfCheckData.length; i++) {
        var goodNum_1 = 0, warningNum_1 = 0, errorNum_1 = 0;
        for (var j = 0; j < selfCheckData[i].CheckingProps.length; j++) {
          var goodNum_2 = 0, warningNum_2 = 0, errorNum_2 = 0;
          for (var k = 0; k < selfCheckData[i].CheckingProps[j].StatuProps.length; k++) {
            if (selfCheckData[i].CheckingProps[j].StatuProps[k].getStatus == 'ERROR') {
              errorNum_2++;
            }
            else if (selfCheckData[i].CheckingProps[j].StatuProps[k].getStatus == 'WARNING') {
              warningNum_2++;
            }
            else {
              goodNum_2++;
            }
          }
          goodNum_1 += goodNum_2;
          warningNum_1 += warningNum_2;
          errorNum_1 += errorNum_2;
        }
        goodNum += goodNum_1;
        warningNum += warningNum_1;
        errorNum += errorNum_1;
      }
      this.props.settingActions.setSelfCheckDataStatusNum({
        goodNum,
        warningNum,
        errorNum
      });
      if (errorNum > 0) {
        this.setState({systemError: 1});
      }
      else if (warningNum > 0 && errorNum == 0) {
        this.setState({
          systemError: 0,
          systemWarning: 1
        });
      }
      else {
        this.setState({
          systemError: 0,
          systemWarning: 0
        });
      }
    }, true);
  }

  getUserList = (callback) => {
    this.props.settingActions.getUserList((data)=>{
      callback && callback(data);
    });
  }

  storeHandler = (props, activeType) => {
    let { backupTreeNode, deviceMonitorTreeMap } = props;
    let groupTreeNode = deviceMonitorTreeMap[backupTreeNode.id];
    // console.log(groupTreeNode);
    this.setState({groupTreeNode});
  }

  getAlarmEventLogs = () => {
    let _endTime = new Date();
    let _startTime = new Date(_endTime.getTime());
    _startTime.setHours(_startTime.getHours() - 2);
    let params = {
      startTime: _startTime.Format('yyyy-MM-dd HH:mm:ss'),
      endTime: _endTime.Format('yyyy-MM-dd HH:mm:ss'),
      currentStatusId: 'IT_AL_ACTIVE',
    };
    this.props.alarmActions.getAlarmEventLogs(params, (alarmEventLogs)=>{
      if (alarmEventLogs && alarmEventLogs instanceof Array) {
        this.setState({alarmEventLogs});
      }
    }, true);
  }

  clickTopMenu = (key) => {
    this.setState({ topMenu: key });
  }

  menuClick = (e) => {
    // console.log(e.key);
    if (e.key == 'logout') {
      const localUserName = Store.get('localUserName');
      this.props.equipmentActions.receiveCreateOperationAudit({
        type: 'logout',
        BoId: 'user',
        OperationDesc: `${localUserName}登出`,
        OperationResults: 1
      }, () => {
        this.props.loginActions.logout(()=>{
          // this.context.router.push("/login");
          this.props.history.push("/login")
        });
      });
    } else if (e.key == 'fullscreen') {
      this.toggleFullscreen();
    } else if (e.key == 'info') {
      // this.context.router.push("/userManage");
      // this.props.checkSubSideCollapsed('/userManage');
      this.props.settingActions.getUserList((data)=>{
        const localUserName = Store.get('localUserName');
        const _user = this.props.userList.find(item => item.LoginID === localUserName);
        _user && this.setState({ personalInfo: _user });
      });
      this.setState({
        personalInfoModalShow: true
      });
      this.props.settingActions.getOrganizationData();
      this.props.settingActions.getAreaData();
      this.props.settingActions.getUnitData();
      this.props.settingActions.getDepartmentData();
    } else if (e.key == 'password') {
      this.setState({
        userManageModalShow: true
      });
    } else if (e.key == 'userManage') {
      this.props.history.push("/userManage")
      // this.context.router.push("/userManage");
      this.props.checkSubSideCollapsed('/userManage');
    }
  }

  toggleFullscreen = () => {
    if (screenfull.enabled) {
      screenfull.toggle();
    } else {
      console.log('Not support fullscreen!');
    }
  }

  menuItem = () => {
    const role = Store.get('CURRENT_ROLENAME');
    if (role == '管理员') {
      return (
        <Menu.Item key="userManage"><TeamOutlined /> 用户管理</Menu.Item>
      )
    } else {
      return
    }
  }

  handleChangeResourceViewType = (activeKey) => {
    this.props.deviceMonitorActions.setResourceViewType(activeKey);
  }

  systemCheck = () => {
    let { selfCheckDataStatusNum } = this.props;
    const { systemError, systemWarning } = this.state;
    if (systemError==1) {
      return (
        <span><Tag color='#ff0000' onClick={this.checkSystem}>错误({selfCheckDataStatusNum.errorNum})</Tag></span>
      )
    } else if (systemWarning==1&&systemError==0) {
      return (
        <span><Tag color='#f50' onClick={this.checkSystem}>危险({selfCheckDataStatusNum.warningNum})</Tag></span>
      )
    } else {
      return (
        <span><Tag color='#5db438' onClick={this.checkSystem}>正常({selfCheckDataStatusNum.goodNum})</Tag></span>
      )
    }
  }

  checkSystem = () =>{
    if (!Utils.hasPermission('system', 'selfcheck')) return;
    // this.context.router.push("/systemDetection");
    this.props.history.push("/systemDetection")
    this.props.checkSubSideCollapsed("/systemDetection");
  }

  checkMonitor = () =>{
    const { nodeData } = this.state;
    // this.context.router.push("/");
    this.props.history.push("/")
    this.props.checkSubSideCollapsed("/");
    this.props.equipmentActions.setOnTreeNodeClick(true);
    this.props.equipmentActions.setSelectedNode(nodeData);
    this.props.equipmentActions.setSelectedClickNode(nodeData);
    this.props.equipmentActions.setBackupTreeNode(nodeData);
  }

  checkUser = () =>{
    if (!Utils.hasPermission('user', '')) return;
    // this.context.router.push("/userManage");
    this.props.history.push("/userManage")
    this.props.checkSubSideCollapsed("/userManage");
  }

  closeModal = () => {
    this.setState({
      userManageModalShow: false
    });
  }

  closePersonalModal = () => {
    this.setState({
      personalInfoModalShow: false
    });
  }

  setDrawerVisible = (drawerVisible) => {
    this.setState({drawerVisible});
  }

  handleMenuChange = () => {
    if (this.props.sideCollapsed) {
      if (this.props.subSideCollapsed) {
        const splitPaneProps = {
          split: 'vertical',
          size: 200,
          minSize: 45,
          maxSize: 600,
        }
        this.props.setSplitPane(splitPaneProps)
      } else {
        const splitPaneProps = {
          split: 'vertical',
          size: 400,
          minSize: 45,
          maxSize: 600,
        }
        this.props.setSplitPane(splitPaneProps)
      }
      this.props.setAppState({sideCollapsed: false});
    } else {
      if (this.props.subSideCollapsed) {
        const splitPaneProps = {
          split: 'vertical',
          size: 45,
          minSize: 45,
          maxSize: 600,
        }
        this.props.setSplitPane(splitPaneProps)
      }
      this.props.setAppState({sideCollapsed: true});
    }
  }

  render(){
    const { topMenu, subMenu, isFullscreen, groupTreeNode, userManageModalShow } = this.state;
    const { resourceViewType, pathname, onlineUserCount, monitorCount, sideCollapsed } = this.props;
    const localUserName = Store.get('localUserName'), role = Store.get('CURRENT_ROLENAME');
    const { menuType, submenuType } = this.props.getMenuSelected();
    const hasAlarmEvent = Utils.hasPermission('alarmEvent', '');
    const menu = (
      <Menu className="light-menu" onClick={this.menuClick}>
        {Utils.hasPermission('personal', '') ? <Menu.Item key="info"><UserOutlined/> 个人信息</Menu.Item> : null}
        {Utils.hasPermission('userrole', 'updatepwd') ? <Menu.Item key="password"><KeyOutlined /> 修改密码</Menu.Item> : null}
        {Utils.hasPermission('user', '') ? this.menuItem() : null}
        <Menu.Item key="logout"><PoweroffOutlined /> 注销登录</Menu.Item>
      </Menu>
    );
    return (
      <div>
        <Header className="header" style={{display: 'flex', alignItems: 'center'}}>
          {
          sideCollapsed?<MenuFoldOutlined onClick={this.handleMenuChange} style={style}/>:<MenuUnfoldOutlined onClick={this.handleMenuChange} style={style}/>
          }
          {/* <Icon type={sideCollapsed ? 'menu-unfold' : 'menu-fold'} style={{color: '#fff', fontSize: 22, marginRight: 8, cursor: 'pointer'}} onClick={this.handleMenuChange}/> */}
          <div className="logo">
            <img src={`images/${Window.AppConfig.loginLogo}`} className="logo_img_weadmin" /> <span style={{paddingLeft: 10, fontSize: 18, color: '#fff', fontWeight: 'bold', fontFamily: 'Helvetica'}}>管理控制台</span>
          </div>
          <div style={{position: 'absolute', left: '12%',height:'27px'}}>
            {
              pathname == '/'
                ? <Tabs className="resourceViewType" type="card" activeKey={resourceViewType} onChange={this.handleChangeResourceViewType}>
                  <TabPane tab="列表" key="列表" />
                  {Utils.hasPermission('topo', 'select') ? <TabPane tab="立体拓扑" key="立体拓扑" /> : null}
                  {Utils.hasPermission('statebatu', '') ? <TabPane tab="状态巴图" key="状态巴图" /> : null}
                  {Utils.hasPermission('matrixview', '') ? <TabPane tab="矩阵树图" key="矩阵树图" /> : null}
                </Tabs>
                : null
            }
          </div>
          <Row type="flex" justify="end" align="middle" className="pull-right rightWarpper" style={{position: 'absolute', right: '1%'}}>
            {
              Utils.isLinux(Store.get("osname")) ?
              <div>
              <Tooltip placement="bottom" title="点击查看">
                <a className="" target="_blank" href={Store.get('vlanUrl')} >
                  <Tag color='#108ee9'> 虚拟组网</Tag>
                </a>
              </Tooltip>
              <Divider type="vertical" className="top-divider"  style={{marginLeft: 7, marginRight: 15}} />
            </div> : null
            }
            <div>
              <Tooltip placement="bottom" title="VLAN发布了新版本，点击前往下载">
                <a className={styles.vlanDownloadLink} target="_blank" rel="noopener noreferrer" href="https://www.vlan.cn">
                  <Tag className={styles.vlanDownloadTag}>
                    <DownloadOutlined className={styles.vlanDownloadIcon} />
                    <span>VLAN新版下载</span>
                    <span className={styles.vlanDownloadNew}>NEW</span>
                  </Tag>
                </a>
              </Tooltip>
              <Divider type="vertical" className="top-divider"  style={{marginLeft: 7, marginRight: 15}} />
            </div>
            {/* {
              Utils.hasPermission('/dashboard') ?
              <div>
                <Tooltip placement="bottom" title="仪表盘中心">
                  <a className="" target="_blank" href={Store.get('dashboardUrl')} style={{fontSize: 12, display: 'inline-block'}}>
                    <Tag color='#108ee9'><DashboardOutlined /> <span className={styles.showNone}>仪表盘中心</span></Tag>
                  </a>
                </Tooltip>
                <Divider type="vertical" className="top-divider"  style={{marginLeft: 7, marginRight: 15}} />
              </div> : null
            } */}
            <div className="info">
              <span><span className={styles.showNone}>系统自检</span> {Utils.hasPermission('system', 'selfcheck') ?
                  <Popover overlayClassName="custom-popover" placement="top" content="点击查看">
                    {this.systemCheck()}
                  </Popover>
                : this.systemCheck()}
              </span>
              <Divider type="vertical" className="top-divider"  style={{marginLeft: 7, marginRight: 15}} />
              <span style={{marginRight: '5px'}}><span className={styles.showNone}>正在运行监测器个数</span></span>
              <Popover overlayClassName="custom-popover" placement="top" content="点击查看">
                <Tag color='#108ee9' onClick={this.checkMonitor}>{monitorCount}</Tag>
              </Popover>
              <Divider type="vertical" className="top-divider" style={{marginLeft: 7, marginRight: 15}} />
              {Utils.hasPermission('user', '') ?
                <Popover overlayClassName="custom-popover" placement="top" content="点击查看">
                  <Tag color='#108ee9' onClick={this.checkUser}>{onlineUserCount}</Tag>
                </Popover>
               : <Tag color='#108ee9' onClick={this.checkUser}>{onlineUserCount}</Tag> }<span className={styles.showNone}>个用户在线</span>
              <Divider type="vertical" style={{marginLeft: 15, marginRight: 0}}  />
            </div>
            <Dropdown overlay={menu}>
              <a className="ant-dropdown-link user-link" >
                <UserOutlined style={{fontSize: 18, marginRight: 3}}/>
                { localUserName } { role ? `[${role}]` : '' } <DownOutlined type="down" style={{marginLeft: 3}} />
              </a>
            </Dropdown>
            <Divider type="vertical" style={{marginLeft: 2, marginRight: 2, marginTop: 5}}  />
            <a className="user-link"  onClick={this.toggleFullscreen}>
              {
              isFullscreen?<FullscreenOutlined style={{fontSize: 16, marginRight: 0}}/>:<FullscreenExitOutlined style={{fontSize: 16, marginRight: 0}}/>
              }
            </a>
            {/* <Menu className="top-menu"
              theme=""
              mode="horizontal"
              defaultSelectedKeys={['1']}
              style={{ lineHeight: '55px', width: hasAlarmEvent ? 240 : 210}}
              onClick={this.menuClick}
            >
              <SubMenu className="light-submenu" style={{left: 'inherit', right: '10px!important'}} title={<span className="submenu-title-wrapper"><Icon type="user" style={{fontSize: 16, marginRight: 3}} />{ localUserName } { role ? `[${role}]` : '' }</span>}>
                {Utils.hasPermission('user', '') ? <Menu.Item key="info"><Icon type="user" /> 个人信息</Menu.Item> : null}
                {Utils.hasPermission('userrole', 'updatepwd') ? <Menu.Item key="password"><Icon type="key" /> 修改密码</Menu.Item> : null}
                {this.menuItem()}
                <Menu.Item key="logout"><Icon type="poweroff" /> 注销登录</Menu.Item>
              </SubMenu>
              <Menu.Item key="setting:2" disabled className="divider-item" style={{padding: 0}}><Divider type="vertical" style={{margin: '0 3px'}} /></Menu.Item>
              <Menu.Item key="fullscreen"><Icon type={isFullscreen ? "fullscreen-exit" : "fullscreen"} style={{fontSize: 16, marginRight: 0}} /></Menu.Item>
              {hasAlarmEvent ? <Menu.Item key="setting:3" disabled className="divider-item" style={{padding: 0}}><Divider type="vertical" style={{margin: '0 3px'}} /></Menu.Item> : null}
            </Menu> */}
            {hasAlarmEvent ? <Divider type="vertical" className="top-divider" style={{marginLeft: 2, marginRight: 15, marginTop: 5}} /> : null}
            {hasAlarmEvent ? <Badge count={this.state.alarmEventLogs.length} offset={[-10, 15]} className="nav-alert">
              <div className="alarmNavIcon" onClick={()=>{this.setDrawerVisible(true)}}>
                <IconFont type="icon-alert-1" />
              </div>
            </Badge> : null}
          </Row>
        </Header>
        <Modal
          width={600}
          title={'更改密码'}
          open={userManageModalShow}
          onCancel={this.closeModal}
          footer={null}
          destroyOnClose
          maskClosable={false}
        >
          <ChangePasswordFormModal localUserName={localUserName} closeModal={this.closeModal}/>
        </Modal>
        <Modal
          width={600}
          title={'个人信息'}
          open={this.state.personalInfoModalShow}
          onCancel={this.closePersonalModal}
          footer={null}
          destroyOnClose
          maskClosable={false}
        >
          {this.state.personalInfo.LoginID ? <UserFormModal selectedUser={this.state.personalInfo} userManageModalType="edit_user" personalInfo={true} getUserList={pathname == '/userManage' ? this.getUserList : null} closeModal={this.closePersonalModal} setState={(state)=>this.setState(state)} /> : null}
        </Modal>
        <Drawer
          width={500}
          placement="right"
          className='DrawerWrip'
          title={<div  className="drawerView-header">报警事件（最近两小时报警事件）</div>}
          closable
          onClose={()=>this.setDrawerVisible(false)}
          open={this.state.drawerVisible}
          destroyOnClose
        >
          <DrawerEventLogsView alarmEventLogs={this.state.alarmEventLogs} />
        </Drawer>
      </div>
    )
  }
}

// AppNavbar.contextTypes = {
//   router: PropTypes.object
// }

// export default AppNavaBar;
const mapStateToProps = (state) => {
  const { selfCheckData, selfCheckDataStatusNum, userList } = state.settingReducer;
  const { backupTreeNode } = state.equipmentReducer;
  const { resourceViewType } = state.deviceMonitorReducer
  const { deviceMonitorTreeMap } = state.deviceMonitorTreeReducer;
  const { monitorCount, onlineUserCount } = state.navbarReducer;
  const { alarmEventList } = state.alarmReducer;
  return {
    selfCheckData,
    selfCheckDataStatusNum,
    userList,
    backupTreeNode,
    resourceViewType,
    deviceMonitorTreeMap,
    monitorCount,
    alarmEventList,
    onlineUserCount
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loginActions: bindActionCreators(loginActions,dispatch),
    alarmActions: bindActionCreators(alarmActions, dispatch),
    settingActions: bindActionCreators(settingActions, dispatch),
    navbarActions:bindActionCreators(navbarActions,dispatch),
    deviceMonitorActions:bindActionCreators(deviceMonitorActions,dispatch),
    equipmentActions:bindActionCreators(equipmentActions,dispatch),
    // operationAuditActions:bindActionCreators(operationAuditActions,dispatch)
  }
}
export default (connect(
  mapStateToProps,
  mapDispatchToProps, null, { forwardRef: true }
)((AppNavbar)))
